export const SET_PASSWORD = 'user/v1/set-password';
export const REGISTER_EMPLOYEE = 'user/v1/register-employee';
export const USER_LOGIN = 'user/v1/login';
export const SSO_LOGIN = 'user/v1/fetch-saml-user-data';
export const USER_RESET_OTP_SEND = 'user/v1/send-otp';
export const USER_RESET_OTP_VALIDATE = 'user/v1/validate-otp';
export const USER_PINCODE = 'master/v1/state-district';
export const SAVE_LEAD = 'lead/v1/save-or-update-lead';
export const LEAD_LIST = 'lead/v1/fetch-lead';
export const STATE_LIST = 'master/v1/states';
export const BRAND_LIST = 'master/v1/branches';
export const CREATED_BY_LIST = 'user/v1/fetch-createdby';
export const LOAN_PRODUCT = 'master/v1/category';
export const REJECT_REASONS_CATEGORY = 'master/v1/rejection-categories';
export const LOAN_PURPOSE = 'master/v1/sub-category';
export const REJECT_REASONS_SUB_CATEGORY = 'master/v1/rejection-subcategories';
export const REJECT = 'lead/v1/reject-lead';
export const MEETING_FREQUENCY = 'master/v1/category';
export const SAVE_PLATFORM = 'loan/platform/v1/save-or-update-platform';
export const SAVE_MCC = 'mcc/v1/save-or-update-mcc';
export const FETCH_MCC = '/mcc/v1/fetch-mcc';
export const FETCH_PLATFORM = 'loan/platform/v1/fetch-platform';
export const FETCH_GEOLOCATION = 'loan/platform/v1/fetch-geolocation';
export const LOGOUT = 'user/v1/logout';
export const FETCH_QDE = '/loan/v1/loan-applications-list';
export const FETCH_LOAN_APPLICATION = '/loan/v2/loan-application-stage-count';
export const FETCH_KYC_DETAILS = '/qde/v1/fetch-kyc-details';
export const FETCH_PERSONAL_DETAILS = '/qde/v1/fetch-los-personal-info';
export const FETCH_PRODUCT_SELECTION = '/qde/v1/fetch-product-selection';
export const FETCH_REJECTED_LOANS = '/loan/v1/fetch-reject-loan-application';
export const FETCH_CO_APPLICANTS = '/loan/v1/co-applicants-list';
export const BUREAU_REPORT = '/loan/v2/bureau-report';
export const FETCH_DOCUMENT_DETAILS = '/qde/v1/fetch-document';
export const SAVE_KYC_DOC = 'qde/v2/save-kyc-details';
export const FORM_CONFIG = '/platform/v1/form-config';
export const FETCH_FORMS = '/platform/v1/fetch-forms';
export const FETCH_APPLICANT_LIST = 'loan/v1/fetch-applicants-details';
export const FETCH_BANK_ACCOUNTS = '/dde/v1/fetch-bank-accounts';
export const FETCH_INSURANCE_CROSS_SELL = '/dde/v1/fetch-insurance-cross-sell';
export const FETCH_CATTLE_DETAILS = '/dde/v1/fetch-cattle-details';
export const FETCH_LAND_DETAILS = '/dde/v1/fetch-land-details';
export const FETCH_OTHER_INCOME_DETAILS = '/dde/v1/fetch-other-income-details';
export const FETCH_HOUSEHOLD_EXPENSE = '/dde/v1/fetch-household-expenses';
export const FETCH_NET_INCOME = '/dde/v1/fetch-net-income';
export const FETCH_REFERENCE_DETAILS = '/dde/v1/fetch-reference-details';
export const FETCH_AGRICULTURAL_DETAILS = '/dde/v1/fetch-agricultural-details';
export const FETCH_DOCUMENTS_LIST = '/qde/v1/fetch-document-list';
export const DELETE_OTHER_UPLOADED_DOC = '/dde/v1/delete-other-uploaded-doc';
export const FETCH_FEES_AND_CHARGES = '/dde/v2/fetch-fees-and-charges';
export const SAVE_OR_UPDATE_CATTLE_DETAILS =
  '/dde/v1/save-or-update-cattle-details';
export const SAVE_OR_UPDATE_OTHER_INCOME =
  '/dde/v1/save-or-update-other-income';
export const SAVE_OR_UPDATE_HOUSEHOLD =
  '/dde/v1/save-or-update-household-expenses';
export const SAVE_OR_UPDATE_REFERENCE =
  '/dde/v1/save-or-update-reference-details';
export const SAVE_OR_UPDATE_INSURANCE_SELL =
  '/dde/v1/save-or-update-insurance-cross-sell';

export const FETCH_CO_APPLICANTS_LIST = '/loan/v1/co-applicants-list';
export const SAVE_OR_UPDATE_NET_INCOME = '/dde/v1/save-or-update-net-income';
export const FETCH_ROLE_DATA = '/user-casbin/v1/casbin-all-permission';
export const LOAN_REJECT = '/loan/v1/reject-loan-application';
export const DOWNLOAD_FI_IMAGE = '/fi/v1/download-fi-image';
export const REJECT_AND_HOLD_FETCH = '/loan/v1/fetch-loan-applications-list';
export const STATUS_CHECK_ACTION = '/loan/v1/applicant-status';
export const STAGE_TRANSITION = 'orchestrator/v1/stage-transition';
export const ONHOLD_STAGE_TRANSITION = 'orchestrator/v1/on-hold';
export const SEND_BACK_TRANSITION = 'orchestrator/v1/send-back';
export const LOAN_DROPDOWN_ENDPOINT = 'master/v1/category';
export const LOAN_SUB_DROPDOWN_ENDPOINT = 'master/v1/sub-category';
export const FETCH_ROLE_DETAILS = 'master/v1/level-role-details';
export const LOAN_DOCUMENT_DETAILS =
  '/master/v1/loan-document-template-details';
export const RESUME = 'orchestrator/v1/resume';
export const REFRESH = '/authenticate/refresh';
export const ADD_UPDATE_OBLIGATION =
  'credit/obligations/v1/bureau-add-update-loan-details';
export const FETCH_OBLIGATION =
  'credit/obligations/v1/fetch-bureau-loan-details';
export const DELETE_OBLIGATION =
  'credit/obligations/v1/delete-bureau-loan-details';
export const FETCH_EXISTING_LOAN =
  'credit/obligations/v1/fetch-samasta-loan-details';
export const SAVE_EXISTING_LOAN =
  'credit/obligations/v1/samasta-save-loan-details';
export const FETCH_CREDIT_RECOMMENDATION =
  'credit/obligations/v1/credit-recommendations';
export const SAVE_CREDIT_RECOMMENDATION =
  'credit/obligations/v1/save-credit-recommendations';
export const FETCH_ELIGIBILTY_DETAILS =
  'credit/eligibility/v1/fetch-product-details';
export const FETCH_DEVIATIONS = 'credit/eligibility/v1/deviation';
export const FETCH_ELIGIBILITY_CHECK =
  'credit/eligibility/v2/check-eligibility';
export const ADD_DEVIATION = 'credit/eligibility/v1/deviation-add';
export const EDIT_DEVIATION = 'credit/eligibility/v1/deviation-edit';
export const APPROVE_REJECT_DEVIATION =
  'credit/eligibility/v1/deviation-approve-reject';
export const ADD_DEVIATION_RECOMMENDATION =
  '/credit/eligibility/v1/add-deviation-recommendation';
export const DELETE_DEVIATION = 'credit/eligibility/v1/delete-deviation';
export const FETCH_BORROWER_DETAIL = 'credit/cam/v1/fetch-borrower';
export const FETCH_CATTLE_DRY_DETAILS =
  'credit/cam/v1/fetch-cattle-dairy-income';
export const FETCH_CREDIT_REC_DETAIL =
  'credit/cam/v1/fetch-credit-recommendation';
export const FETCH_CREDIT_BUREAU = 'credit/cam/v1/fetch-credit-bureau';
export const FETCH_PROPOSAL_DETAIL = 'credit/cam/v1/proposal';
export const FETCH_CASH_FLOW = 'credit/cam/v1/fetch-cash-flow-analysis';
export const FETCH_DISBURSEMENT_DETAIL =
  'booking/disbursement/v1/fetch-disbursement-details';
export const FETCH_SCHEDULE = 'booking/loanBooking/v1/schedule';
export const FETCH_FEE_CHARGES = 'booking/loanBooking/v1/fee-charges';
export const FETCH_PRODUCT_DETAILS = 'master/v1/dcl-product-details';
export const UPLOAD_DOCUMENT = '/booking/document/v1/document-upload';
export const DOWNLOAD_DOCUMENT = '/booking/document/v1/document-download';
export const FETCH_DOC_DISBURSEMENT_DETAIL =
  '/booking/document/v1/fetch-document-disbursement-detail';
export const FETCH_LOAN_DOCUMENT_LIST =
  '/booking/document/v1/fetch-loan-document-list';
export const CAM_PDF_VIEW = '/template/v1/cam-pdfs';
export const INITIATE_DISBURSEMENT_DETAIL =
  'booking/disbursement/v1/initiate-transfer';
export const DISBURSEMENT_DROPDOWN =
  'master/v1/disbursement-bank-account-details';
export const APPROVE_DOCUMENT = '/booking/document/v1/document-approve';
export const REJECT_DOCUMENT = '/booking/document/v1/document-reject';
export const GENERATE_PDF = 'template/v1/generate-pdfs';
export const UPLOAD_DISBURSEMENT =
  'booking/disbursement/v1/transfer-status-upload';
export const DOWNLOAD_DISBURSEMENT =
  'booking/disbursement/v1/transfer-queue-csv';
export const REPAYMENT_SCHEDULE = '/booking/loanBooking/v1/repayment-schedule';
export const ESIGN_BUTTON_STATUS = 'booking/esign/v1/esign-button-status';
export const INITIATE_ESIGN = 'booking/esign/v1/esign-initiate';
export const ESIGN_DETIALS = 'booking/esign/v1/esign-details';
export const SEND_BACK_OPTION = '/loan/v1/fetch-loan-allowed-transactions';
export const SEND_KFS = '/booking/loanBooking/v1/send-kfs-to-applicant';
export const OPEN_LOAN_ACCOUNT = '/booking/loanBooking/v1/openLoanAccount';
export const FETCH_HISTORY = '/loan/history/v1/history';
export const FETCH_PROFILE = '/user/v1/fetch-my-profile';
export const FETCH_VALIDATION = '/loan/history/v1/validation-summary';
export const FETCH_LOAN_SEARCH = '/loan/v1/loan-search';
export const FETCH_PLATFORM_APPLICANTS =
  '/loan/reassign/v1/platform-loan-application';
export const FETCH_PLATFORM_NAMES = '/loan/reassign/v1/platform-names';
export const REASSIGN_PLATFORM = '/loan/reassign/v1/platform-reassign';
export const FETCH_API_LOG = '/platform/v1/fetch-api-log-list';
export const FETCH_API_NAMES = '/platform/v1/fetch-api-names';
export const FETCH_LOAN_SEARCH_PRODUCT = 'master/v1/fetch-loan-product-master';
export const FETCH_CO_LENDING_MASTER = 'master/v1/fetch-co-lending-master';
export const FETCH_BANK_MASTER = 'master/v1/fetch-bank-master';
export const FETCH_PINCODE_MASTER = 'master/v1/fetch-pincode-master';
export const FETCH_BRANCH_MASTER = 'master/v1/fetch-branch-master';
export const FETCH_STATE_MASTER = '/master/v1/fetch-state-master';
export const FETCH_ASSIGNEE_NAME = '/loan/reassign/v1/employee-names';
export const REASSIGN_SO_PLATFORM = '/loan/reassign/v1/platform-reassign-so';
export const ADD_UPDATE_BANK_MASTER = 'master/v1/add-or-update-bank-details';
export const FETCH_BANK_DETAILS_BY_IFSC = 'master/v1/bank-details';
export const ADD_BANK_ACCOUNT_DETAILS = 'dde/v1/add-bank-account-details';
export const DELETE_BANK_ACCOUNT = 'dde/v1/delete-bank-account';
export const BANK_VERIFICATION = 'dde/v1/bank-verification';
export const ADD_UPDATE_PINCODE_MASTER =
  'master/v1/add-or-update-pincode-master';
export const FETCH_EMPLOYEES = '/user/v1/fetch-employees';
export const FETCH_SO_NAMES = '/lead/v1/reassign-names';
export const REASSIGN_LEAD = 'lead/v1/reassign-lead';
export const FETCH_APPLICATION =
  '/loan/reassign/v1/fetch-loan-for-reassignment';
export const REASSIGN_APPLICATION =
  '/loan/reassign/v1/loan-application-reassign';
export const FETCH_PLATFORM_SLOTS = '/loan/reassign/v1/platform-details';
export const ADD_UPDATE_STATE_MASTER = 'master/v1/upsert-state';
export const BULK_UPLOAD_MASTER = 'master/v1/bulk-upload';
export const BULK_DOWNLOAD_MASTER = 'master/v1/download-template';
export const FETCH_GLOBAL_CONFIG = '/master/v1/fetch-global-configuration';
export const UPDATE_GLOBAL_CONFIG = '/master/v1/update-global-configuration';
export const FETCH_BRANCH_CONFIG = '/master/v1/fetch-branch-configuration';
export const UPDATE_BRANCH_CONFIG =
  '/master/v1/add-update-branch-configuration';
export const FETCH_PRODUCT_CONFIG = '/master/v1/fetch-product-configuration';
export const UPDATE_PRODUCT_CONFIG =
  'master/v1/add-update-product-configuration';
export const PRODUCT_LIST = '/master/v1/fetch-product-master';
export const STAGES = 'loan/v1/fetch-loan-stage-list';
export const DOC_LIST = '/master/v1/fetch-kyc-document-master';
export const BRANCH_CONFIG_LIST = '/master/v1/fetch-state-branch-list';
export const LOAN_APP_LOG_LIST = '/platform/v1/fetch-loan-application-details';
export const LOAN_APP_LOG_DETAIL_LIST =
  '/platform/v1/fetch-loan-application-logs';
export const TAB_STAGE_VAL = '/platform/v2/fetch-loan-application-logs-stages';
export const BRANCH_TAG_LIST = '/platform/v1/fetch-branch-role';
export const UPI_STATUS = '/booking/document/v1/upi-mandate-status';
export const UPI_MANDATE = '/booking/document/v1/upi-mandate-initiate';
export const ADD_UPDATE_BRANCH_MASTER =
  '/master/v1/add-or-update-branch-details';
export const ADD_UPDATE_COLENDING_MASTER =
  '/master/v1/add-update-co-lending-master';
export const FETCH_PARTNER_DROPDOWN = '/master/v1/fetch-partner-master';
export const ADD_UPDATE_LOAN_PRODUCT_MASTER =
  '/master/v1/upsert-product-master';
export const REPORT_MASTER = '/master/v1/reports';
export const DOWNLOAD_REPORT = '/report/v1/download-report';
export const DOWNLOAD_REPORT_PORTFOLIO = '/report/v1/download-report-v3';
export const PARTNER_NAME = '/master/v1/fetch-partner-master';
export const DISTANCE_PLATFORM = '/master/v1/fetch-branch-config-detail';
export const FETCH_ROLE_REPORT = '/master/v1/fetch-role-report-mapping';
export const FETCH_ROLE_LIST = '/master/v1/fetch-role-master';
export const FETCH_REPORT_DROPDOWN = '/master/v1/fetch-report-master';
export const ADD_UPDATE_ROLE_REPORT = '/master/v1/map-role-report-mapping';
export const FETCH_BRANCH_PRODUCT = '/master/v1/fetch-branch-to-product-master';
export const PRODUCT_CATEGORY_DROPDOWN = '/master/v1/fetch-product-category';
export const ADD_UPDATE_BRANCH_PRODUCT =
  '/master/v1/add-update-branch-to-product-master';
export const DELETE_FILE_DEVIATION =
  '/credit/eligibility/v1/delete-deviation-file';
export const LOGGED_ROLE_REPORT = 'master/v1/fetch-logged-role-report-mapping';
export const USER_ROLES = '/user/v1/get-roles';
export const GENERATE_TOKEN = 'user/v1/regenerate-token';
export const FETCH_USER_MASTER = '/master/v1/fetch-user-details';
export const PRODUCT_BY_BRANCH_USER = '/master/v1/fetch-products-by-branch';
export const SAVE_USER_MASTER = '/master/v1/add-or-update-user-details';
export const FORCE_LOGOUT = '/user/v1/force-logout';
export const PARTNER_CODE_DROPDOWN = '/master/v1/fetch-partner-master';
export const LOGGED_IN_USER_LIST = '/user/v1/logged-in-user-list';
export const USER_ROLE_NAME_LIST = '/master/v1/fetch-all-role-details';
export const NOTIFICATION_COUNT = '/platform/v1/fetch-notifications-count';
export const FETCH_NOTIFICATION = '/platform/v1/fetch-notifications';
export const UPDATE_NOTIFICATION = '/platform/v1/update-notitification-status';
export const FETCH_PREVIOUS_KYC = '/loan/v1/fetch-approval-status';
export const FETCH_USER_BRANCHES = '/user/v1/get-user-branches';
export const UPSERT_CONVERSATION = '/loan/v1/upsert-conversation';
export const TAG_USER_DROPDOWN = '/loan/v1/fetch-tag-users';
export const FETCH_CONVERSATION = '/loan/v1/fetch-conversations';
export const FETCH_ROLE_MASTER = '/master/v1/fetch-roles-list';
export const ADD_UPDATE_ROLE_MASTER = '/master/v1/upsert-roles';
export const FETCH_SERVICE_LIST = '/user/v1/fetch-service-master';
export const FETCH_PRODUCT_SERVICES = '/user/v1/fetch-product-services';
export const FETCH_PRODUCT_STAGES = '/user/v1/fetch-product-stages';
export const FETCH_GLOBAL_PERMISSION =
  '/user/v1/fetch-sections-for-global-permissions';
export const FETCH_PRODUCT_PERMISSION =
  '/user/v1/fetch-tabs-sections-permissions';
export const SAVE_GLOBAL_PERMISSION = '/user/v1/save-global-permissions';
export const SAVE_PRODUCT_PERMISSION = '/user/v1/save-role-permissions';
export const FETCH_ALLOWED_DOCUMENT_LIST =
  '/master/v1/fetch-allowed-document-list';
export const FETCH_CUSTOMERS = '/customer/customer/v1/fetch-customers';
export const FETCH_CUSTOMER_DETAILS =
  '/customer/customer/v1/fetch-customer-details';
export const FETCH_KYC_DOCUMENTS_LIST = '/customer/v1/fetch-kyc-documents-list';
export const FETCH_KYC_DOCUMENTS = '/customer/v1/fetch-kyc-details';
export const FETCH_CUSTOMER_LOANS = '/customer/v1/fetch-customer-loans';
export const FETCH_CUSTOMER_LOAN_DETAILS =
  '/customer/v1/fetch-customer-loan-details';
export const LMS_BR_NET_API_CALL =
  '/booking/disbursement/v1/lms-br-net-api-call';
export const FETCH_DOCUMENT_TEMPLATE = '/master/v1/fetch-document-template';
export const SAVE_DOCUMENT_TEMPLATE = '/master/v1/save-document-template';
export const FETCH_TEMPLATE_VARIABLES = '/master/v1/fetch-template-variables';
export const FETCH_BANK_STATEMENT_BASE64 =
  'loan/dde/v1/fetch-bank-account-statement';
export const UPLOAD_BANK_STATEMENT =
  'loan/dde/v1/upload-bank-account-statement';
export const DELETE_BANK_STATEMENT =
  'loan/dde/v1/delete-bank-account-statement';
export const BR_NET_PRE_CLOSURE = 'credit/obligations/v1/brnet-preclosure';
export const FETCH_USER_PRODUCT_CATEGORIES =
  '/user/v1/fetch-user-product-categories';
export const FETCH_CONSUMER_DETAILS = 'loan/cd/v1/fetch-cd-code-details';
export const ORDER_CONFIRMATION_DOWNLOAD =
  'loan/oc/v1/order-confirmation-download';
export const ORDER_CONFIRMATION_BULK_UPLOAD =
  'loan/oc/v1/order-confirmation-bulk-upload';
export const ORDER_CONFIRMATION_FETCH =
  'loan/oc/v1/fetch-order-confirmation-details';
export const ORDER_CONFIRMATION_DOCUMENT =
  'loan/oc/v1/fetch-order-confirmation-document';
export const ORDER_CONFIRMATION_FILE_DELETE =
  'loan/oc/v1/order-confirmation-file-delete';
export const ORDER_CONFIRMATION_FILE_UPLOAD =
  'loan/oc/v1/order-confirmation-file-upload';
export const ORDER_CONFIRMATION_SAVE = 'loan/oc/v1/order-confirmation-save';
export const UPDATE_CONSUMER_MASTER = '/master/v1/consumer-durables';
export const FETCH_CD_MASTER = '/master/v1/fetch-cd-master';
